import {
    set,
    axios,
    config,
} from '../actions/types';

const initialState = {
    sidebarShow: 'responsive',
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case set:
            return {
                ...state,
                val: true
            }
        default:
            return state
    }
}